import { Schema as S } from "effect";
export const Schema = S.Literal("stripe");
export const Value = "stripe";
